import { Fuel } from "lucide-react";
import { useState, useEffect, useRef } from "react";

// Mantém o loader visível por um tempo mínimo (evita "piscar" e padroniza o tempo entre as telas).
export function useMinLoading(active, minMs = 1000) {
  const [show, setShow] = useState(active);
  const start = useRef(active ? Date.now() : 0);
  useEffect(() => {
    if (active) { start.current = Date.now(); setShow(true); return; }
    const elapsed = Date.now() - (start.current || Date.now());
    const t = setTimeout(() => setShow(false), Math.max(0, minMs - elapsed));
    return () => clearTimeout(t);
  }, [active]);
  return show;
}

/**
 * Loader orbital — mesma estrutura/parâmetros do loader do sistema Expressa
 * (anéis girando 10s + 14s reverse, glow pulsando 2.5s), mas com uma
 * BOMBA DE COMBUSTÍVEL ao centro no lugar do cifrão, e cores do posto.
 */
export default function Loader({ label = "Carregando...", className = "" }) {
  return (
    <div className={`loader-wrap ${className}`} data-testid="loader">
      <span className="fuel-globe" aria-hidden="true">
        <span className="fg-glow" />
        <span className="fg-ring fg-r1"><span className="fg-dot" /></span>
        <span className="fg-ring fg-r2" />
        <span className="fg-core"><Fuel size={42} strokeWidth={2.2} /></span>
      </span>
      {label && <span className="loader-label">{label}</span>}
    </div>
  );
}
